module.exports = __webpack_public_path__ + "img/bs_silo_2.388d4e57.png";